<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b> {{getTitle()}} </b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p> <b>Datos del Estudiante para registrar:</b> </p>
                <p class="text-primary"> <b>Usuario Moodle:</b> {{this.obj.estudiante.usuario_moodle}} </p>
                <p class="text-primary"> <b>Clave Moodle:</b> {{this.obj.estudiante.clave_moodle}} </p>
                <p class="text-primary"> <b>Nombres:</b> {{this.obj.estudiante.nombres}} </p>
                <p class="text-primary"> <b>Apellidos:</b> {{this.obj.estudiante.pri_apellido}} {{this.obj.estudiante.seg_apellido}} </p>
                <p class="text-primary"> <b>Correo:</b> {{this.obj.estudiante.email}} </p>
                <p class="text-primary"> <b>Telefono:</b> {{this.obj.estudiante.telefono1}} </p>
                <small class="text-primary"> <p>El resultado de la operacion se notifica a: <b> <input type="email" v-model="correo_to"> </b> </p> </small>
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'La operacion se realizo satisfactoriamente, revise el correo para ver el resultado.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="submit" :disabled="!activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xusername:Object,xestado:Number}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                correo_to:null,
                activo: true,
                estado: 0,
            }
        },
        watch:{
            'obj.xid': function(){ 
                if( this.obj.xid == null ) return;
                this.$refs.alertar.reset(); 
                this.activo = true;
                window.console.log( "MODALLLLLLLLLLLLLLLLll" ); 
                if( !this.obj.estudiante.seg_apellido ) this.obj.estudiante.seg_apellido = '';

                if( !this.obj.sede.correos ){
                  this.activo = false;
                  this.$refs.alertar.invalido("ERROR: la sede no tiene correo."); 
                }else{
                  var cor = this.obj.sede.correos.find( x => x.tipo == 0 );
                  if( cor ) {
                      window.console.log( "MODALLLLLLLLLLLLLLLLll",cor ); 
                      this.correo_to = cor.direccion;
                  }else{
                      this.activo = false;
                      this.$refs.alertar.invalido("ERROR: la sede no tiene correo del tipo 0 (corporativo)."); 
                  }
                }
            },
            'obj':function(){ 
                this.$refs.alertar.reset();
                this.activo = true;
            }
        },
        components:{Alertas}, 
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
            getTitle(){
                if( this.obj.update ) return "Actualizar Participante en Moodle";
                else return "Registrar Participante en Moodle";
            },
            submit(){
                if( !this.obj.sede.correos ){
                  this.activo = false;
                  this.$refs.alertar.invalido("ERROR: la sede no tiene correo."); 
                }else if(this.correo_to){
                    this.mail( this.correo_to );
                }else{
                    this.activo = false;
                    this.$refs.alertar.invalido("ERROR: la sede no tiene correo del tipo 0 (corporativo)."); 
                }
            },
            mail( email ){
                this.$refs.alertar.cargando(); 
                this.estado = parseInt( this.estado )
                window.console.log( "ZZZZ ",this.obj );

                //{}

                var correo = {
                  "data":{
                    "attendant":{
                      "name": "Registro Estudiante Moodle",
                      "mail": email 
                    },
                    "student":{
                      "username": this.obj.estudiante.usuario_moodle,
                      "password": this.obj.estudiante.clave_moodle,
                      "firstname": this.obj.estudiante.nombres,
                      "lastname": this.obj.estudiante.pri_apellido+' '+this.obj.estudiante.seg_apellido,
                      "email": this.obj.estudiante.email,
                      "phone": this.obj.estudiante.telefono1,
                    }
                  }
                }
                var data = JSON.stringify(correo);
                var vue = this;

                // window.console.log( "CORREITO> ",data )
                // window.console.log( "CORREITO> ",correo )
                var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+'create-student-notification';
                if( this.obj.update ) url = process.env.VUE_APP_URL_NOTIFIER_ESAM+'update-student-notification'

                var config = {
                    method: 'post',
                    url: url,
                    headers: { 
                        'Content-Type': 'application/json'
                    },
                    data : data
                    };

                window.axios(config)
                    .then(function (res) {
                        // window.console.log('--------------------- RESPUESTA DEL SERVIDOR --------------------------')
                        const data = res.data
                        // window.console.log(res.data)
                        // window.console.log(data)
                        // window.console.log( window.stringifyObject(data) )
                        vue.msg = 'enviado'
                        vue.$refs.alertar.success( data.moodle+', '+data.mail );
                        vue.$emit('exito');
                    })
                    .catch(function (error) {
                        vue.$refs.alertar.invalido(); 
                        window.console.error(error)
                        vue.msg = error
                });
            }
        },
  mounted(){
    var vue = this;
    window.$('#modalmoodle').on('hidden.bs.modal',function(){
      vue.msg = ''
      //vue.programa = {}
      vue.activo = true;
      vue.$refs.alertar.reset();
    })
    
  }
    }
</script>